import React, { Fragment, Component } from 'react'
// import { Table, Button } from 'semantic-ui-react'

import AddModal from '../components/AddModal'
import Page from '../components/Page'

class SystemAdmins extends Component {
    state = {
        reports: [{ id: 1 }],
        filteredList: [{ id: 1 }],
        loading: false,
        error: null,
    }

    render() {
        const { filteredList, loading, error } = this.state

        return (
            <Page
                icon="users"
                name="System Admins"
                length={filteredList.length}
                loading={loading}
                error={error}
                tableHeaders={["ID", "User name", "User Group", "User email", "Enabled", "Created", ""]}
                tableBody={() => (
                    <Fragment>
                        {/* {filteredList.map(report =>
                            <Table.Row key={report.id} >
                                <Table.Cell>{report.id}</Table.Cell>
                                <Table.Cell>{report.name}</Table.Cell>
                                <Table.Cell>{report.manufacturer}</Table.Cell>
                                <Table.Cell>{report.created}</Table.Cell>
                                <Table.Cell collapsing>
                                    <Fragment>
                                        <Button primary content="Select" />
                                        <Button color="black" content="Delete" />
                                    </Fragment>
                                </Table.Cell>
                            </Table.Row>
                        )} */}
                    </Fragment>
                )}
                addNew={() => (
                    <AddModal
                        header="system admin"
                        fields={["name",]}
                        onSave={() => window.alert("hmm")}
                    />
                )}
            />
        )
    }
}

export default SystemAdmins

